// import Promise from 'pinkie-promise';
const initialState = {
  isShow: false,
  // 字符串/组件
  title: null,
  // 字符串/组件
  content: '',
  subContent: '',
  htmlContent: '',
  // OK_CANCEL / OK / 组件
  buttons: 'OK',
  buttonText: {
    OK: '确定',
    CANCEL: '取消',
  },
  promise: null,
};

export class DialogStore {
  constructor() {
    this.state = { ...initialState };
  }

  show(options) {
    const { state } = this;
    Object.assign(state, initialState, options, {
      isShow: true,
    });
    return new Promise((resolve, reject) => {
      state.promise = { resolve, reject };
    });
  }

  confirm({
    title, content, subContent, buttonText, htmlContent,
  }) {
    return this.show({
      title,
      content,
      subContent,
      htmlContent,
      buttons: 'OK_CANCEL',
      buttonText: buttonText || {
        OK: '确定',
        CANCEL: '取消',
      },
    });
  }

  info({ title, content }) {
    return this.show({ title, content, buttons: 'OK' });
  }

  hide(isOk) {
    const { state } = this;
    state.isShow = false;
    if (state.promise) {
      if (isOk === true) {
        state.promise.resolve();
      } else {
        state.promise.reject();
      }
    }
  }
}

const defaultDialogStore = new DialogStore();
export default defaultDialogStore;
